import axios, {
  getDataRequest,
  postDataRequest,
  postMultiPartRequest,
  // formatQueryResponse,
} from "../helper/AxiosHelper";
import ApiHelper from "./ApiHelper";
import { getStoredAccount } from "../helper/AccountHelper";

// ----------------------------------------------------------------------
// #region Others

const loginWithAccessToken = async (accessToken) => {
  const data = {
    access_token: accessToken,
  };

  const response = await axios.post("/admin/loginWithAccessToken", data);

  return ApiHelper.processResponse(response);
};


const refreshOrganizationAccessToken = async (orgId, adminUserId) => {
  const data = {
    organization_id: orgId,
    admin_user_id: adminUserId,
  };

  const response = await axios.post("/admin/refreshOrganizationAccessToken", data);

  return ApiHelper.processResponse(response);
};

const login = async (account, password) => {
  const data = {
    account: account,
    password: password,
  };

  const response = await axios.post("/admin/login", data);

  return ApiHelper.processResponse(response);
};

const logout = async (email, password) => {
  const data = {};

  const response = await axios.post("/admin/logout", data);

  return ApiHelper.processResponse(response);
};

const checkSkillInput = async (eventID, qrCode, skill, score, skillInputData) => {
  const data = {
    event_id: eventID,
    qrcode_id: qrCode,
    skill_code: skill,
    skill_score: score,
    skill_input_data: skillInputData,
  };

  const url = `/admin/checkSkillInput`;

  const response = await axios.post(url, data);

  return ApiHelper.processResponse(response);
};

const submitScoreQRCode = async (eventID, qrCode, skillCode, skillScore) => {
  const data = {
    event_id: eventID,
    qrcode_id: qrCode,
    skill_code: skillCode,
    skill_score: skillScore,
  };

  const url = `/admin/submitScoreQR`;

  const response = await axios.post(url, data);

  return ApiHelper.processResponse(response);
};

// Depm
const submitScore = async (memberID, eventID, skillCode, skillScore, skillInputData) => {

  const skillInputDataForServer = {
    values: skillInputData.valueArray,
  }

  const data = {
    member_id: memberID,
    event_id: eventID,
    skill_code: skillCode,
    skill_score: skillScore,
    skill_input_data: skillInputDataForServer,
  };

  console.debug("inputData: ", data);

  const url = `/admin/submitScore`;

  const response = await axios.post(url, data);

  return ApiHelper.processResponse(response);
};


const loadEventLeaderboardData = async (
  eventID,
  startDate,
  endData,
) => {
  const url = `/admin/eventLeaderboardData/${eventID}?start_date=${startDate}&end_date=${endData}`;
  const data = {};
  // console.log("loadEventLeaderboard: ", url);

  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};


const loadEventLeaderboardCallback = async (
  eventID,
  date,
  timeslotID,
  callback
) => {
  console.debug("loadEventLeaderboardCallback: ", eventID, date, timeslotID);

  const result = await loadEventLeaderboard(eventID, date, timeslotID);

  console.debug("loadEventLeaderboardCallback: result: ", result);

  if (callback) {
    console.debug("loadEventLeaderboardCallback: result: ", result);
    if (result == null || result === undefined) {
      console.error("invalid result");
      return;
    }
    callback(result);
  }
};

const loadEventLeaderboard = async (
  eventID,
  date,
  timeslotID,

  showDetail = false
) => {
  const url = `/admin/eventLeaderboard/${eventID}?date=${date}&timeslot_id=${timeslotID}&show_detail=${showDetail}`;
  const data = {};
  console.log("loadEventLeaderboard: ", url);

  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};

// ------------------

const loadEventMonthlyLeaderboardCallback = async (eventID, date, callback) => {
  const result = await loadEventMonthlyLeaderboard(eventID, date);
  if (callback) {
    console.debug("loadEventMonthlyLeaderboardCallback: result: ", result);
    if (result == null || result === undefined) {
      console.error("invalid result");
      return;
    }
    callback(result);
  }
};

const loadEventMonthlyLeaderboard = async (eventID, date) => {
  const url = `/admin/eventMonthlyLeaderboard/${eventID}?date=${date}`;
  const data = {};

  console.log("loadEventMonthlyLeaderboard: ", url);
  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};

// ------------------

const loadEventOverallLeaderboardCallback = async (eventID, date, callback) => {
  const result = await loadEventOverallLeaderboard(eventID, date);
  if (callback) {
    console.debug("loadEventOverallLeaderboard: result: ", result);
    if (result == null || result === undefined) {
      console.error("invalid result");
      return;
    }
    callback(result);
  }
};

const loadEventOverallLeaderboard = async (eventID, date) => {
  const url = `/admin/eventOverallLeaderboard/${eventID}?date=${date}`;
  const data = {};

  console.log("loadEventOverallLeaderboard: ", url);
  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};

const loadSingleEventLeaderboardCallback = async (
  eventID,
  date,
  timeslotID,
  skillCode,
  callback = () => { }
) => {
  const result = await loadSingleEventLeaderboard(
    eventID,
    date,
    timeslotID,
    skillCode
  );

  if (callback === undefined) {
    console.warn("loadSingleEventLeaderboardCallback: callback is undefined");
    return;
  }

  if (result == null || result === undefined || result.length === 0) {
    console.debug("loadSingleEventLeaderboardCallback: no result");
    callback(null);
    return;
  }

  callback(result[0]);
  return result[0];
};

const loadSingleEventLeaderboard = async (
  eventID,
  date,
  timeslotID,
  skillCode
) => {
  const url = `/admin/eventLeaderboard/${eventID}?skill=${skillCode}&date=${date}&timeslot_id=${timeslotID}`;
  const data = {};

  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};

const loadSingleEventOverallLeaderboardCallback = async (
  eventID,
  date,
  queryCode,
  callback
) => {
  const result = await loadSingleEventOverallLeaderboard(
    eventID,
    date,
    queryCode
  );
  if (callback) {
    console.debug("loadEventOverallLeaderboard: result: ", result);
    if (result == null || result === undefined) {
      console.error("invalid result");
      return;
    }
    callback(result);
  }

  return result;
};

const loadSingleEventOverallLeaderboard = async (eventID, date, queryCode) => {
  const url = `/admin/singleEventOverallLeaderboard/${eventID}?date=${date}&query_code=${queryCode}`;
  const data = {};

  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};

const previewHealthData = async (eventID, fileObject) => {
  if (fileObject === null || fileObject === undefined) {
    throw new Error("File is not selected");
  }

  if (fileObject.name.endsWith(".csv") === false) {
    throw new Error("請上載 CSV 檔案");
  }

  const url = `/admin/previewHealthData`;

  const formData = new FormData();
  formData.append("event_id", eventID);
  formData.append("file", fileObject);

  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const response = await axios.post(url, formData, options);

  return ApiHelper.processResponse(response);
};

const importHealthData = async (eventID, fileObject) => {
  if (fileObject === null || fileObject === undefined) {
    throw new Error("File is not selected");
  }

  if (fileObject.name.endsWith(".csv") === false) {
    throw new Error("請上載 CSV 檔案");
  }

  const url = `/admin/importHealthData`;

  const formData = new FormData();
  formData.append("event_id", eventID);
  formData.append("file", fileObject);

  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const response = await axios.post(url, formData, options);

  return ApiHelper.processResponse(response);
};


const searchHealthData = async (keyword) => {
  if (keyword === null || keyword === undefined) {
    throw new Error("keyword is not selected");
  }

  const url = `/admin/searchHealthData?keyword=${keyword}`;

  const formData = {}

  const response = await axios.get(url, formData);

  return ApiHelper.processResponse(response);
};

// const
// const importHealthData = async (eventID, fileObject) => {

/// --- Get Organization
const getOrgnizationDetailCallback = (orgId, callback) => {
  const url = `/organization/show/${orgId}`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    // _data.login_access_token = _data.login_access_token; // ken: XXX: Hardcode first


    callback(true, "", _data);
    // queryResultSetter(() => formatQueryResponse(_data));
    // backdropSetter(() => false);
  });

  // let urlWithQuery = `${fetchDataConfig.url}?query=${JSON.stringify(query)}`;
  // if ("extraQuery" in fetchDataConfig) {
  //   fetchDataConfig.extraQuery.forEach((extraQueryParma) => {
  //     if (urlParma[extraQueryParma.field] === undefined) return;
  //     urlWithQuery += `&${extraQueryParma.key}=${
  //       urlParma[extraQueryParma.field]
  //     }`;
  //   });
  // }
  // getDataRequest(urlWithQuery, (isSuccess, _data) => {
  //   if (!isSuccess) {
  //     return false;
  //   }
  //   queryResultSetter(() => formatQueryResponse(_data));
  //   backdropSetter(() => false);
  // });
  //
  //getDataRequest(`organization/show/${orgId}`, (isSuccess, data) => {
  // const url = `/admin/getOrgnizationID/${orgId}`;
  // const data = {};

  // const response = await axios.get(url, data);

  // return ApiHelper.processResponse(response);
};

const getOrgnizationListCallback = (callback) => {
  const url = `/organization`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
    // queryResultSetter(() => formatQueryResponse(_data));
    // backdropSetter(() => false);
  });
};

const batchInsertSkillScore = async (formData, callback) => {
  const response = await postDataRequest(
    "/admin/batchSubmitScore",
    formData,
    (isSuccess, _data) => {
      if (!isSuccess) {
        let msg = _data;
        callback(false, msg, null); // _data is error message
        return;
      }

      callback(true);
      // queryResultSetter(() => formatQueryResponse(_data));
      // backdropSetter(() => false);
    }
  );

  return ApiHelper.processResponse(response);
};

const getEquCateListCallback = (callback) => {
  const url = `/equipmentCategory`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
    // queryResultSetter(() => formatQueryResponse(_data));
    // backdropSetter(() => false);
  });
};

const insertEquipmentData = async (formData, callback) => {
  const response = await postDataRequest(
    "/equipment/create",
    formData,
    (isSuccess, _data) => {
      if (!isSuccess) {
        let msg = _data;
        callback(false, msg, null); // _data is error message
        return;
      }

      callback(true);
      // queryResultSetter(() => formatQueryResponse(_data));
      // backdropSetter(() => false);
    }
  );

  return ApiHelper.processResponse(response);
};

const updateEquipmentData = async (equId, formData, callback) => {
  const response = await postDataRequest(
    "/equipment/update/" + equId,
    formData,
    (isSuccess, _data) => {
      if (!isSuccess) {
        let msg = _data;
        callback(false, msg, null); // _data is error message
        return;
      }

      callback(true);
      // queryResultSetter(() => formatQueryResponse(_data));
      // backdropSetter(() => false);
    }
  );

  return ApiHelper.processResponse(response);
};



const getMemberEventHealthInfoCallback = (eventID, qrCode, callback) => {
  const url = `/memberEventHealthInfo/getInfo?event_id=${eventID}&qrcode=${qrCode}`;

  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }
    console.log("getMemberEventHealthInfoCallback: ", _data);

    callback(true, "", _data);
  });
};


const updateMemberEventHealthInfo = async (eventID, data, callback) => {
  const url = `/memberEventHealthInfo/updateInfo`;

  data.event_id = eventID;

  const response = await postDataRequest(
    url,
    data,
    (isSuccess, message, responseData) => {
      console.log("updateMemberEventHealthInfo1111: ",
        isSuccess, " responseData:", responseData);
      if (!isSuccess) {
        callback(false, message, null); // _data is error message
        return;
      }

      let { success, msg, result } = responseData;
      if (success === false) {
        callback(false, msg, null); // _data is error message
        return;
      }
      // console.log("****** updateMemberEventHealthInfo: ", success
      //   , msg, result);

      callback(true, "", result.record);
      // queryResultSetter(() => formatQueryResponse(_data));
      // backdropSetter(() => false);
    }
  );

  return ApiHelper.processResponse(response);
};

const exportHealthAndSkillSummary = (eventID, callback) => {
  const url = `/event/exportFindEventHealthAndSkillSummary?event_id=${eventID}`;

  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }
    console.log("exportHealthAndSkillSummary: ", _data);

    callback(true, "", _data);
  });
};

// getEventRedemptionDetailByQRCode
const getEventRedemptionDetailByQRCode = async (eventID, qrCode) => {
  const url = `/admin/getEventRedemptionDetailByQRCode?event_id=${eventID}&qrcode=${qrCode}`;
  const formData = {}

  const response = await axios.get(url, formData);

  return ApiHelper.processResponse(response);
};

const getRedemptionInfoByQRcode = async (qrcode) => { // this is redeem qrCode 

  const url = `/admin/getRedemptionInfoByQRCode?qrcode=${qrcode}`;

  const formData = {}

  const response = await axios.get(url, formData);

  return ApiHelper.processResponse(response);
};

const markRedeemedByID = async (redemptionId) => {
  const url = `/admin/markRedeemedByID`;

  const formData = {
    redemption_id: redemptionId,
  }

  const response = await axios.post(url, formData);

  return ApiHelper.processResponse(response);
}


const changePasswordByPhoneNum = async (phoneNum, newPassword) => {
  const url = `/admin/changePasswordByPhoneNum`;

  const formData = {
    phone_num: phoneNum,
    new_password: newPassword,
    access_token: "XYZSDFA123124"   // ken: XXX: Hardcode first
  }

  const response = await axios.post(url, formData);

  return ApiHelper.processResponse(response);
}

// ----------------------------------------------------------------------
const loadCoSportTopRanking = async () => {
  const url = `/admin/analytic/skillTopOrganization`;
  const data = {};
  console.log("loadCoSportTopRanking: ", url);

  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};


const loadCoSportAnalytics = async (orgType) => {
  const url = `/admin/analytic/skillStatistics?org_type=${orgType}`;
  const data = {};
  console.log("loadCoSportTopRanking: ", url);

  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};


const loadCoSportSkillScore = async (eventID, skillCode) => {
  const url = `/admin/analytic/coSportSkillScore?event_id=${eventID}&skill_code=${skillCode}`;
  const data = {};
  console.log("loadCoSportSkillScore: ", url);

  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};

const loadOrgMissionSettingList = async (orgID) => {

  const url = `/organization/${orgID}/missing_settings`;
  const data = {};
  console.log("loadOrgMissionSettingList: ", url);
  const response = await axios.get(url, data);

  return ApiHelper.processResponse(response);
};

/// ----------------------------------------------------------------
/// Organisation Mission Settings 
/// 

const loadOrgMissionSettingListCallback = (orgID, callback) => {
  const url = `/organization/${orgID}/missing_settings`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  });
};


const createMissionSettingCallback = async (formData, callback) => {
  const response = await postDataRequest(
    "/organization/createOrgMissionSetting",
    formData,
    (isSuccess, _data, result) => {
      if (!isSuccess) {
        let msg = _data;
        console.log("createMissionSettingCallback: _data=", _data, " result=", result);
        callback(false, msg, null); // _data is error message
        return;
      }

      let record = result.result;
      if (record === null || record === undefined) {
        callback(false, "No record return", null);
        return;
      }

      callback(true, "", record);
    }
  );

  return ApiHelper.processResponse(response);
};


const updateMissionSettingCallback = async (formData, callback) => {
  const response = await postDataRequest(
    "/organization/updateOrgMissionSetting",
    formData,
    (isSuccess, _data, result) => {
      if (!isSuccess) {
        let msg = _data;
        callback(false, msg, null); // _data is error message
        return;
      }

      let record = result.result;
      if (record === null || record === undefined) {
        callback(false, "No record return", null);
        return;
      }

      console.log("updateMissionSettingCallback: ", record);
      callback(true, "", record);
    }
  );

  return ApiHelper.processResponse(response);
};



const getOrgMissionSettingCallback = (orgID, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  const url = `/organization/getOrgMissionSetting/${orgID}`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  });
};

const getDashboardDataCallback = async (callback) => {

  const url = `/admin/getDashboardData`;

  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    console.log("getDashboardDataCallback: ", _data);

    callback(true, "", _data);
  });

}

// #endregion
// ----------------------------------------------------------------------
// ----------------------------------------------------------------------
// #region Member FaceLogin 
const enrollMemberFace = async (memberID, data, _callback) => {


  data.member_id = memberID;

  // console.log("enrollMemberFace: _callback=", _callback);

  const url = `/admin/enrollMemberFace`;

  await postMultiPartRequest(
    url,
    data,
    (isSuccess, message, responseData) => {
      // console.log("enrollMemberFace: ",
      // isSuccess, " responseData:", responseData);
      if (!isSuccess) {
        _callback(false, message, null); // _data is error message
        return;
      }

      // console.log("enrollMemberFace: responseData: ", responseData);

      let { success, msg, result } = responseData;
      if (success === false) {
        _callback(false, msg, null); // _data is error message
        return;
      }

      // console.log("enrollMemberFace: XXX: ", result);
      _callback(true, "", {
        face_id: result.face_id,
      });
      // _result = result;
    }
  );
};

const clearMemberFace = async (memberID, _callback) => {
  const url = `/admin/clearMemberFace`;

  const data = {
    member_id: memberID,
  };

  await postDataRequest(
    url,
    data,
    (isSuccess, message, responseData) => {
      // console.log("enrollMemberFace: ",
      // isSuccess, " responseData:", responseData);
      if (!isSuccess) {
        _callback(false, message, null); // _data is error message
        return;
      }

      let { success, msg, result } = responseData;
      if (success === false) {
        _callback(false, msg, null); // _data is error message
        return;
      }

      console.log("clearMemberFace: ", result);
      _callback(true, "", {});
      // _result = result;
    }
  );
}

const batchCreateMember = async (orgID, password, fileObject) => {
  if (fileObject === null || fileObject === undefined) {
    throw new Error("沒有選擇檔案");
  }
  if (fileObject.name.endsWith(".csv") === false) {
    throw new Error("請上載 CSV 檔案");
  }

  const url = `/adminMember/batchMemberCreation`;

  const formData = new FormData();
  formData.append("organization_id", orgID);
  formData.append("password", password);
  formData.append("file", fileObject);

  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };

  const response = await axios.post(url, formData, options);

  return ApiHelper.processResponse(response);
};

const deleteScoreRecord = async (recordID) => {
  // get token from  
  let token = process.env.REACT_APP_ACCESS_TOKEN;

  const url = `/admin/deleteScoreRecord`;
  const data = {
    record_id: recordID,
    access_token: token, // ken: XXX: Hardcode first
  };
  console.log("deleteScoreRecord: ", url, " data: ", data);
  const response = await axios.post(url, data);
  return ApiHelper.processResponse(response);
};



// const previewHealthData = async (eventID, fileObject) => {
//   if (fileObject === null || fileObject === undefined) {
//     throw new Error("File is not selected");
//   }

//   if (fileObject.name.endsWith(".csv") === false) {
//     throw new Error("請上載 CSV 檔案");
//   }

//   const url = `/admin/previewHealthData`;

//   const formData = new FormData();
//   formData.append("event_id", eventID);
//   formData.append("file", fileObject);

//   const options = {
//     headers: {
//       "Content-Type": "multipart/form-data",
//     },
//   };

//   const response = await axios.post(url, formData, options);

//   return ApiHelper.processResponse(response);
// };


// #endregion
// ----------------------------------------------------------------------

// ----------------------------------------------------------------------
// #region Export


// ----------------------------------------------------------------------
// #region School Leaderboard
const getSchoolLeaderboardCallback = (orgID, mode, filters, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/schoolLeaderboard/${orgID}`;

  // Add the query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("mode", mode);
  queryParams.append("filters", JSON.stringify(filters));

  url += `?${queryParams.toString()}`;


  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  });
};


// #endregion


// #region Org Monthly Stats
const getOrgDashboardDataCallback = (orgID, year, startMonth, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/orgStat/getDashboardData`;

  // Add the query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("org_id", orgID);
  queryParams.append("year", year);
  queryParams.append("start_month", startMonth);

  url += `?${queryParams.toString()}`;
  const axiosOptions = {
    suppressAlert: true, // Custom option to suppress alert
  }
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  }, axiosOptions);
};

// #endregion


// #region Org Monthly Stats
const getMonthlyParticipantDataCallback = (orgID, year, startMonth, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/orgStat/getMonthlyParticipantData`;

  // Add the query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("org_id", orgID);
  queryParams.append("year", year);
  queryParams.append("start_month", startMonth);

  url += `?${queryParams.toString()}`;
  const axiosOptions = {
    suppressAlert: true, // Custom option to suppress alert
  }
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  }, axiosOptions);
};


// #region Org Monthly Stats
const getSkillParticipantDataCallback = (orgID, year, startMonth, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/orgStat/getSkillParticipantData`;

  // Add the query parameters
  const queryParams = new URLSearchParams();
  queryParams.append("org_id", orgID);
  queryParams.append("year", year);
  queryParams.append("start_month", startMonth);

  url += `?${queryParams.toString()}`;
  const axiosOptions = {
    suppressAlert: true, // Custom option to suppress alert
  }
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  }, axiosOptions);
};




const getEventParticipantOverviewCallback = (eventID, callback) => {
  // {{host}}/api/organization/getOrgMissionSetting/1
  let url = `/admin/getEventParticipantOverview/${eventID}`;

  // Add the query parameters
  const queryParams = new URLSearchParams();

  url += `?${queryParams.toString()}`;
  const axiosOptions = {
    suppressAlert: true, // Custom option to suppress alert
  }
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      let msg = _data;
      callback(false, msg, null); // _data is error message
      return;
    }

    callback(true, "", _data);
  }, axiosOptions);
};

// #endregion

// #region Dashboard Video 

const getDashboardVideoListCallback = (callback) => {
  const url = `/dashboardVideo`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      callback(false, _data, null);
      return;
    }
    callback(true, "", _data);
  });
};

const getDashboardVideoDetailCallback = (recordId, callback) => {
  const url = `/dashboardVideo/show/${recordId}`;
  getDataRequest(url, (isSuccess, _data) => {
    if (!isSuccess) {
      callback(false, _data, null);
      return;
    }
    callback(true, "", _data);
  });
};

const getDashboardVideoDetail = async (recordId) => {
  const url = `/dashboardVideo/show/${recordId}`;
  const formData = {}

  const response = await axios.get(url, formData);

  return ApiHelper.processResponse(response);
};

const createDashboardVideoCallback = async (formData, callback) => {
  const response = await postMultiPartRequest(
    "/dashboardVideo/create",
    formData,
    (isSuccess, _data, result) => {
      if (!isSuccess) {
        callback(false, _data, null);
        return;
      }
      callback(true, "", result);
    }
  );
  return ApiHelper.processResponse(response);
};

const updateDashboardVideoCallback = async (dashboardID, formData, callback) => {

  const response = await postMultiPartRequest(
    `/dashboardVideo/update/${dashboardID}`,
    formData,
    (isSuccess, _data, result) => {
      if (!isSuccess) {
        callback(false, _data, null);
        return;
      }
      callback(true, "", result);
    }
  );
  return ApiHelper.processResponse(response);
};

const deleteDashboardVideoCallback = async (dashboardID, callback) => {
  const response = await postDataRequest(
    `/dashboardVideo/delete/${dashboardID}`,
    {},
    (isSuccess, _data, result) => {
      if (!isSuccess) {
        callback(false, _data, null);
        return;
      }
      callback(true, "", result);
    }
  );
  return ApiHelper.processResponse(response);
};

const usernameSetupTimeout = 15 * 60 * 1000;

const usernameSetupAccount = () => {
  const account = getStoredAccount();
  if (!account) {
    return "";
  }
  return account.username || account.email || "";
};

const getUsernameSetupSummary = async (orgId) => {
  const response = await axios.get(`/usernameSetup/summary/${orgId}`, {
    timeout: usernameSetupTimeout,
  });
  return ApiHelper.processResponse(response);
};

const previewUsernameSetup = async (orgId, payload) => {
  const response = await axios.post(
    `/usernameSetup/preview`,
    {
      organization_id: Number(orgId),
      admin_account: usernameSetupAccount(),
      ...payload,
    },
    { timeout: usernameSetupTimeout }
  );
  return ApiHelper.processResponse(response);
};

const commitUsernameSetup = async (orgId, payload) => {
  const response = await axios.post(
    `/usernameSetup/commit`,
    {
      organization_id: Number(orgId),
      admin_account: usernameSetupAccount(),
      ...payload,
    },
    { timeout: usernameSetupTimeout }
  );
  return ApiHelper.processResponse(response);
};

const memberImportForm = (orgId, file, passwordMode, password, matchBy, removeMissing) => {
  const formData = new FormData();
  formData.append("organization_id", orgId);
  formData.append("password_mode", passwordMode);
  formData.append(
    "password",
    passwordMode === "custom" ? password.trim() : ""
  );
  formData.append("match_by", matchBy === "username" ? "username" : "name");
  formData.append("remove_missing", removeMissing === "yes" ? "yes" : "no");
  formData.append("admin_account", usernameSetupAccount());
  formData.append("file", file);
  return formData;
};

const previewMemberImport = async (orgId, file, passwordMode, password, matchBy, removeMissing) => {
  const response = await axios.post(
    `/memberImport/preview`,
    memberImportForm(orgId, file, passwordMode, password, matchBy, removeMissing),
    {
      timeout: usernameSetupTimeout,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return ApiHelper.processResponse(response);
};

const commitMemberImport = async (orgId, file, passwordMode, password, matchBy, removeMissing) => {
  const response = await axios.post(
    `/memberImport/commit`,
    memberImportForm(orgId, file, passwordMode, password, matchBy, removeMissing),
    {
      timeout: usernameSetupTimeout,
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
  return ApiHelper.processResponse(response);
};

const guestAccountPayload = (orgId, count, passwordMode, password) => ({
  organization_id: Number(orgId),
  admin_account: usernameSetupAccount(),
  count: String(count).trim(),
  password_mode: passwordMode,
  password: passwordMode === "custom" ? password.trim() : "",
});

const previewGuestAccounts = async (orgId, count, passwordMode, password) => {
  const response = await axios.post(
    `/memberImport/guestPreview`,
    guestAccountPayload(orgId, count, passwordMode, password),
    { timeout: usernameSetupTimeout }
  );
  return ApiHelper.processResponse(response);
};

const commitGuestAccounts = async (orgId, count, passwordMode, password) => {
  const response = await axios.post(
    `/memberImport/guestCommit`,
    guestAccountPayload(orgId, count, passwordMode, password),
    { timeout: usernameSetupTimeout }
  );
  return ApiHelper.processResponse(response);
};

// #endregion

// ----------------------------------------------------------------------

export const AdminApi = {
  login,
  logout,
  getEventParticipantOverviewCallback,
  getSkillParticipantDataCallback,
  getMonthlyParticipantDataCallback,
  getOrgDashboardDataCallback,
  getSchoolLeaderboardCallback,
  batchCreateMember,
  enrollMemberFace,
  clearMemberFace,
  deleteScoreRecord,
  getDashboardDataCallback,
  getOrgMissionSettingCallback,
  createMissionSettingCallback,
  updateMissionSettingCallback,
  loginWithAccessToken,
  loadCoSportSkillScore,
  loadCoSportAnalytics,
  loadCoSportTopRanking,
  refreshOrganizationAccessToken,
  changePasswordByPhoneNum,
  markRedeemedByID,
  getRedemptionInfoByQRcode,
  exportHealthAndSkillSummary,
  updateMemberEventHealthInfo,
  getMemberEventHealthInfoCallback,
  previewHealthData,
  importHealthData,
  getOrgnizationListCallback,
  getOrgnizationDetailCallback,
  getUsernameSetupSummary,
  previewUsernameSetup,
  commitUsernameSetup,
  previewMemberImport,
  commitMemberImport,
  previewGuestAccounts,
  commitGuestAccounts,
  loadEventLeaderboardData,
  loadEventLeaderboard,
  loadEventLeaderboardCallback,
  loadSingleEventLeaderboardCallback,
  loadEventOverallLeaderboard,
  loadEventOverallLeaderboardCallback,
  loadEventMonthlyLeaderboard,
  loadEventMonthlyLeaderboardCallback,
  loadSingleEventOverallLeaderboard,
  loadSingleEventOverallLeaderboardCallback,
  checkSkillInput,
  submitScore,
  deleteScoreRecord,
  submitScoreQRCode,
  batchInsertSkillScore,
  getEquCateListCallback,
  insertEquipmentData,
  updateEquipmentData,
  searchHealthData,
  getEventRedemptionDetailByQRCode,
  loadOrgMissionSettingList,
  loadOrgMissionSettingListCallback,
  getDashboardVideoListCallback,
  getDashboardVideoDetailCallback,
  createDashboardVideoCallback,
  updateDashboardVideoCallback,
  deleteDashboardVideoCallback,
  getDashboardVideoDetail,
};
// #endregion
// ----------------------------------------------------------------------
